import React from "react";
import { useDispatch } from "react-redux";
import { signOut } from "../../redux/actions/currentProfileActions";
import { MdLogout } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { logOutOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";

function LogoutBtn() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleClick = async () => {
    dispatch(signOut());
  };
  return (
    <button
      onClick={() => handleClick()}
      className="profile-action-btn logout-btn"
    >
      <IonIcon slot="start" icon={logOutOutline} className="btn-icon" />
      {/* <MdLogout className="btn-icon" /> */}
      <span className="btn-text">{t("signOut")}</span>
    </button>
  );
}

export default LogoutBtn;
